(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arrival-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // Same playback nudge pattern as password-antechamber.
    function nudgeVideoPlayback(video) {
      if (!video || prefersReducedMotion()) return;

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      function tryPlay() {
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () { /* blocked, retry below */ });
        }
      }

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener('loadeddata', tryPlay, { once: true });
        video.addEventListener('canplay', tryPlay, { once: true });
      }

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && video.paused) tryPlay();
      });

      const onInteract = function () {
        if (video.paused) tryPlay();
        window.removeEventListener('pointerdown', onInteract);
        window.removeEventListener('keydown', onInteract);
        window.removeEventListener('scroll', onInteract);
      };
      window.addEventListener('pointerdown', onInteract, { passive: true });
      window.addEventListener('keydown', onInteract);
      window.addEventListener('scroll', onInteract, { passive: true });
    }

    function init(root) {
      if (!root || root.dataset.arrivalReady === 'true') return;
      root.dataset.arrivalReady = 'true';
      const video = root.querySelector('[data-arrival-video]');
      nudgeVideoPlayback(video);
    }

    function initAll() {
      document.querySelectorAll('.arrival-hero').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-antechamber"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const KEY_NUM = 'pantao:member:number';
    const KEY_EDITION = 'pantao:member:edition';
    const KEY_POSTED = 'pantao:member:posted';
    const NUMBER_REVEAL_DELAY_MS = 400;
    const NUMBER_REVEAL_DURATION_MS = 900;

    function pad(n, width) {
      const s = String(n);
      return s.length >= width ? s : '0'.repeat(width - s.length) + s;
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // Encourage a hero <video> to actually autoplay. Browsers require the
    // video to be muted to autoplay without a user gesture, but they still
    // sometimes refuse to start, especially on iOS Safari and in background
    // tabs. We set the muted *property* (not just the attribute) and call
    // play() explicitly, then retry when the tab becomes visible.
    function nudgeVideoPlayback(video) {
      if (!video) return;

      // Bail out for visitors who prefer reduced motion — CSS hides the
      // element, but we shouldn't waste bandwidth either.
      if (prefersReducedMotion()) return;

      // Setting the property is what actually convinces some browsers.
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      function tryPlay() {
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {
            // Autoplay was blocked. We'll retry on visibility change /
            // first interaction below. No console noise.
          });
        }
      }

      // Try right away.
      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener('loadeddata', tryPlay, { once: true });
        // Some Safari versions need this fallback event.
        video.addEventListener('canplay', tryPlay, { once: true });
      }

      // Retry when the tab becomes visible (handles "opened in background").
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && video.paused) tryPlay();
      });

      // Retry on the first user interaction with the page, as a last resort.
      // Browsers ALWAYS allow muted playback after a user gesture.
      const onInteract = function () {
        if (video.paused) tryPlay();
        window.removeEventListener('pointerdown', onInteract);
        window.removeEventListener('keydown', onInteract);
        window.removeEventListener('scroll', onInteract);
      };
      window.addEventListener('pointerdown', onInteract, { passive: true });
      window.addEventListener('keydown', onInteract);
      window.addEventListener('scroll', onInteract, { passive: true });
    }

    function init(root) {
      if (!root || root.dataset.antechamberReady === 'true') return;
      root.dataset.antechamberReady = 'true';

      const startNumber = parseInt(root.dataset.startNumber, 10) || 0;
      const edition = root.dataset.editionPrefix || '';
      const accepted = root.dataset.accepted === 'true';

      const numberEl = root.querySelector('[data-member-number]');
      const invitationState = root.querySelector('.antechamber__state--invitation');
      const acceptedState = root.querySelector('.antechamber__state--accepted');
      const form = root.querySelector('.antechamber__form');
      const submitBtn = form ? form.querySelector('.antechamber__submit') : null;
      const video = root.querySelector('[data-antechamber-video]');

      // Coax the hero video into autoplaying — runs before any other
      // init logic so the visual lands as quickly as possible.
      nudgeVideoPlayback(video);

      function getOrAssignNumber() {
        let stored = localStorage.getItem(KEY_NUM);
        const storedEdition = localStorage.getItem(KEY_EDITION);

        // If edition has changed (new drop year), re-issue a number.
        if (storedEdition !== edition) stored = null;

        let n = stored ? parseInt(stored, 10) : NaN;
        if (!Number.isFinite(n)) {
          const jitter = Math.floor(Math.random() * 7) + 1;
          n = startNumber + jitter;
          try {
            localStorage.setItem(KEY_NUM, String(n));
            localStorage.setItem(KEY_EDITION, edition);
          } catch (e) { /* storage blocked */ }
        }
        return n;
      }

      function setNumberStatic() {
        if (!numberEl) return;
        numberEl.textContent = pad(getOrAssignNumber(), 4);
      }

      function animateNumber(targetN) {
        if (!numberEl) return;
        if (prefersReducedMotion()) {
          numberEl.textContent = pad(targetN, 4);
          return;
        }
        const start = performance.now();
        function frame(now) {
          const t = Math.min(1, (now - start) / NUMBER_REVEAL_DURATION_MS);
          // Ease-out cubic
          const eased = 1 - Math.pow(1 - t, 3);
          const current = Math.floor(eased * targetN);
          numberEl.textContent = pad(current, 4);
          if (t < 1) requestAnimationFrame(frame);
          else numberEl.textContent = pad(targetN, 4);
        }
        requestAnimationFrame(frame);
      }

      // Show the accepted state instantly (no animation) — used for
      // returning visitors who already saw the ceremony in a previous session.
      function revealAcceptedInstant() {
        if (!acceptedState) return;
        if (invitationState) invitationState.hidden = true;
        acceptedState.hidden = false;
        setNumberStatic();
      }

      // Validate required fields (HTML5 already does it, but we want to
      // surface errors before kicking off the fetch).
      function validate() {
        if (!form) return false;
        if (typeof form.reportValidity === 'function') {
          return form.reportValidity();
        }
        return true;
      }

      function setBusy(isBusy) {
        if (!submitBtn) return;
        submitBtn.setAttribute('aria-busy', isBusy ? 'true' : 'false');
        submitBtn.disabled = !!isBusy;
      }

      // ---- Page-load behavior ----

      // 1) Server-rendered acceptance (Shopify reloaded with customer.posted?).
      //    This happens for the no-JS path. Show accepted state with a gentle
      //    reveal so it doesn't feel like a hard reload.
      if (accepted) {
        if (invitationState) invitationState.hidden = true;
        if (acceptedState) {
          acceptedState.hidden = false;
          acceptedState.classList.add('is-entering');
          void acceptedState.offsetWidth;
          requestAnimationFrame(function () {
            acceptedState.classList.remove('is-entering');
            acceptedState.classList.add('is-entered');
          });
          setTimeout(function () {
            animateNumber(getOrAssignNumber());
          }, NUMBER_REVEAL_DELAY_MS);
        }
        try {
          localStorage.setItem(KEY_POSTED, 'true');
          localStorage.setItem(KEY_EDITION, edition);
        } catch (e) { /* ignore */ }
        return;
      }

      // 2) Returning visitor who signed up in a previous session — show
      //    accepted state immediately (no animation, they've seen this).
      const seenBefore = localStorage.getItem(KEY_POSTED) === 'true';
      const sameEdition = localStorage.getItem(KEY_EDITION) === edition;
      if (seenBefore && sameEdition) {
        revealAcceptedInstant();
        return;
      }

      // 3) New visitor — wire up the form for an animated handoff to the reload.
      //
      //    Implementation note: we deliberately use a NATIVE form submit here
      //    (not fetch). Shopify's spam protection on the customer endpoint
      //    is friendlier to real form submits — AJAX POSTs to /contact can
      //    trigger a human-verification challenge that doesn't render inside
      //    a fetch response. The page reloads with customer.posted? = true,
      //    and the accepted-state branch above (case #1) handles the
      //    entrance animation and number reveal.
      //
      //    The JS-enhanced polish here is only the LEAVE animation: we fade
      //    the invitation state out so the visitor sees a deliberate
      //    departure rather than a hard form post.
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!validate()) {
            e.preventDefault();
            return;
          }

          // Lock in the number now so it's stable across the redirect.
          try {
            localStorage.setItem(KEY_EDITION, edition);
            localStorage.setItem(KEY_POSTED, 'true');
            getOrAssignNumber();
          } catch (err) { /* ignore */ }

          setBusy(true);

          // If reduced motion is preferred, just let the form submit
          // normally — no point staging a transition.
          if (prefersReducedMotion()) return;

          // Otherwise, fade the invitation out before letting the navigation
          // happen. We don't preventDefault — we just delay the visual.
          // The browser will navigate when the form's submission completes;
          // the fade just runs concurrently with the request flight time,
          // which on a fast connection is roughly the same window we need.
          if (invitationState) invitationState.classList.add('is-leaving');
        });
      }
    }

    function initAll() {
      document.querySelectorAll('.antechamber').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
